import React from 'react';
import { Navigate } from 'react-router-dom';

const RouteGuard = ({children}) => {
  let token = localStorage.getItem("g_a");
  if(token){
     return children;
  }else{
     return <Navigate to="/admin/login" />
  }
}

export default RouteGuard
